import ModulesTableDescriptionCell from "./DescriptionCell";
import ModulesTableSpaceCell from "./SpaceCell";
import ModulesTableCreatedAtCell from "./CreatedAtCell";
import ModulesTableLabelsCell from "./LabelsCell";
import ModulesTableNameLinkCell from "./NameCell";
import { MODULES_COLUMN_ID } from "../constants";
import ModulesTableRowActionsCell from "./RowActionsCell";
import ModulesTableVersionCell from "./VersionCell";
import ModulesTableProviderCell from "./ProviderCell";
import ModulesTableProjectRootCell from "./ProjectRootCell";
import ModulesTableRepositoryCell from "./RepositoryCell";
import ModulesTableAvailabilityCell from "./AvailibilityCell";
import ModulesTableFavoriteCell from "./FavoriteCell";
import ModulesTableBranchCell from "./BranchCell";
import ModulesTableIdCell from "./IdCell";
import ModulesTableSettingsCell from "./SettingsCell";

export const MODULES_TABLE_CELLS = {
  [MODULES_COLUMN_ID.VERSION]: ModulesTableVersionCell,
  [MODULES_COLUMN_ID.ID]: ModulesTableIdCell,
  [MODULES_COLUMN_ID.DESCRIPTION]: ModulesTableDescriptionCell,
  [MODULES_COLUMN_ID.NAME]: ModulesTableNameLinkCell,
  [MODULES_COLUMN_ID.FAVORITE]: ModulesTableFavoriteCell,
  [MODULES_COLUMN_ID.AVAILABILITY]: ModulesTableAvailabilityCell,
  [MODULES_COLUMN_ID.SPACE]: ModulesTableSpaceCell,
  [MODULES_COLUMN_ID.PROVIDER]: ModulesTableProviderCell,
  [MODULES_COLUMN_ID.SETTINGS]: ModulesTableSettingsCell,
  [MODULES_COLUMN_ID.PROJECT_ROOT]: ModulesTableProjectRootCell,
  [MODULES_COLUMN_ID.REPOSITORY]: ModulesTableRepositoryCell,
  [MODULES_COLUMN_ID.BRANCH]: ModulesTableBranchCell,
  [MODULES_COLUMN_ID.CREATED_AT]: ModulesTableCreatedAtCell,
  [MODULES_COLUMN_ID.LABELS]: ModulesTableLabelsCell,
  [MODULES_COLUMN_ID.DROPDOWN]: ModulesTableRowActionsCell,
};
